import { Component, input, model, output } from '@angular/core';
import { OpzioneTematica } from 'src/app/services/tematiche/tematiche.service';

@Component({
  selector: 'app-motivazione-risposta-vsme',
  standalone: false,

  templateUrl: './motivazione-risposta-vsme.component.html',
  styleUrl: './motivazione-risposta-vsme.component.scss',
})
export class MotivazioneRispostaVsmeComponent {
  sottoRisposta = model.required<OpzioneTematica>();
  readonly readOnly = input<boolean>(false);
  readonly isPMI = input<boolean>(false);
  readonly isRequired = input<boolean>(false);
  showTouchedField = input<boolean>(false);
  motivazioneChanged = output<boolean>();

  /**
   * Toggle esclusivo tra "Non Disponibile" e "Non Rilevante" per una sotto-risposta.
   * @param sottoRisposta
   * @param tipo
   */
  toggleEsclusivo(tipo: 'disponibile' | 'rilevante') {
    this.sottoRisposta.update((attuale) => {
      // 1. Creiamo una copia profonda (o superficiale se basta) dell'oggetto
      const nuovaSottoRisposta = { ...attuale };

      // 2. Usiamo il controllo di esistenza (Safe Navigation)
      if (tipo === 'disponibile' && nuovaSottoRisposta.infoNonDisponibile?.checked) {
        // Se accendo "Non Disponibile", assicuratevi che infoNonRilevante esista prima di spegnerlo
        if (nuovaSottoRisposta.infoNonRilevante) {
          nuovaSottoRisposta.infoNonRilevante.checked = false;
        }
      } else if (tipo === 'rilevante' && nuovaSottoRisposta.infoNonRilevante?.checked) {
        // Se accendo "Non Rilevante", assicuratevi che infoNonDisponibile esista prima di spegnerlo
        if (nuovaSottoRisposta.infoNonDisponibile) {
          nuovaSottoRisposta.infoNonDisponibile.checked = false;
        }
      }

      return nuovaSottoRisposta;
    });
    this.motivazioneChanged.emit(true);
  }
}
